import {Pattern} from '@domain/pattern';
import {FontSettings} from '@domain/textile-data/finishing-and-finishing-template/finishing/font-settings';
import {isNil} from 'lodash-es';
import {PathLabelInformationForPart} from './path-label-information-for-part';
import {PathLabelType} from './path-label-type.enum';

export class InitialPathLabel {
  private readonly _fontSettings: FontSettings;
  private readonly _labelHeightInMM: number;
  private readonly _labelHeightInPicks: number;
  private readonly _pathLabelType: PathLabelType;
  private readonly _pathLabelInformationAfter: PathLabelInformationForPart;
  private readonly _pathLabelInformationBefore: PathLabelInformationForPart;
  private readonly _pattern: Pattern;

  public constructor(
    fontSettings: FontSettings,
    labelHeightInMM: number,
    labelHeightInPicks: number,
    pathLabelType: PathLabelType,
    placeholderPartsAfter: PathLabelInformationForPart,
    placeholderPartsBefore: PathLabelInformationForPart,
    pattern: Pattern
  ) {
    this._fontSettings = fontSettings;
    this._labelHeightInMM = labelHeightInMM;
    this._labelHeightInPicks = labelHeightInPicks;
    this._pathLabelType = pathLabelType;
    this._pathLabelInformationAfter = placeholderPartsAfter;
    this._pathLabelInformationBefore = placeholderPartsBefore;
    this._pattern = pattern;
  }

  public get fontSettings(): FontSettings {
    return this._fontSettings;
  }

  public get labelHeightInMM(): number {
    return this._labelHeightInMM;
  }

  public get labelHeightInPicks(): number {
    return this._labelHeightInPicks;
  }

  public get pathLabelType(): PathLabelType {
    return this._pathLabelType;
  }

  public get pathLabelInformationAfter(): PathLabelInformationForPart {
    return this._pathLabelInformationAfter;
  }

  public get pathLabelInformationBefore(): PathLabelInformationForPart {
    return this._pathLabelInformationBefore;
  }

  public get pattern(): Pattern {
    return this._pattern;
  }

  public static fromJSON(initialPathLabelJSON: any): InitialPathLabel {
    return !isNil(initialPathLabelJSON)
      ? new InitialPathLabel(
          FontSettings.fromJSON(initialPathLabelJSON),
          initialPathLabelJSON.labelHeightInMM,
          initialPathLabelJSON.labelHeightInPicks,
          initialPathLabelJSON.pathLabelType,
          PathLabelInformationForPart.fromJSON(initialPathLabelJSON.placeholderPartsAfter),
          PathLabelInformationForPart.fromJSON(initialPathLabelJSON.placeholderPartsBefore),
          Pattern.fromJSON(initialPathLabelJSON.pattern)
        )
      : null;
  }
}
